import Phaser from 'phaser';
import { AssetRegistry } from './AssetRegistry';
import { PlayerPreferences } from './PlayerPreferences';

type AdjustableSound = Phaser.Sound.BaseSound & { setVolume?: (volume: number) => unknown; volume?: number };

export class AudioManager {
  static readonly instance = new AudioManager();

  private currentMusic?: Phaser.Sound.BaseSound;
  private currentMusicKey?: string;

  private constructor() {
    if (typeof window !== 'undefined') window.addEventListener('coj:preferences-changed', () => this.refreshMusicVolume());
  }

  playMusic(scene: Phaser.Scene, key: string) {
    const resolved = AssetRegistry.instance.audio(key);
    const settings = PlayerPreferences.instance.value;
    if (!resolved || settings.muted || settings.masterVolume <= 0 || settings.musicVolume <= 0 || this.currentMusicKey === resolved) return;
    this.currentMusic?.stop();
    if (!scene.cache.audio.exists(resolved)) return;
    this.currentMusic = scene.sound.add(resolved, { loop: true, volume: settings.masterVolume * settings.musicVolume });
    this.currentMusic.play();
    this.currentMusicKey = resolved;
  }

  refreshMusicVolume() {
    const settings = PlayerPreferences.instance.value;
    if (!this.currentMusic) return;
    const volume = settings.muted ? 0 : settings.masterVolume * settings.musicVolume;
    const sound = this.currentMusic as AdjustableSound;
    if (typeof sound.setVolume === 'function') sound.setVolume(volume);
    else if ('volume' in sound) sound.volume = volume;
  }

  playUi(scene: Phaser.Scene, key = 'sfx_ui_click_bonang') {
    const resolved = AssetRegistry.instance.audio(key);
    const settings = PlayerPreferences.instance.value;
    if (!resolved || settings.muted || settings.masterVolume <= 0 || settings.sfxVolume <= 0 || !scene.cache.audio.exists(resolved)) return;
    scene.sound.play(resolved, { volume: settings.masterVolume * settings.sfxVolume });
  }

  stopMusic() {
    this.currentMusic?.stop();
    this.currentMusic = undefined;
    this.currentMusicKey = undefined;
  }
}
